export const numberFormat = (number) => {
  const options = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
    currency: "EUR",
    style: "currency",
    currencyDisplay: "symbol",
    decimalSeparator: ",",
    groupingSeparator: ".",
  };
  return new Intl.NumberFormat("de-DE", options).format(number);
};

export const participationsFormat = (number) => {
  const options = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
    decimalSeparator: ",",
    groupingSeparator: ".",
  };
  return new Intl.NumberFormat("de-DE", options).format(number);
};
